import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBorderBottomComponent } from "./med-icon-border-bottom.component";

@NgModule({
  declarations: [
    MedIconBorderBottomComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBorderBottomComponent,
  ],
})
export class MedIconBorderBottomModule { }
